import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
// import * as rp from 'request-promise';
// import Spinner from 'react-bootstrap/Spinner'
// const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID;
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
import IntegrationsSection from 'components/IntegrationsSection'
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import FormGroup from 'components/Form/FormGroup'
import FormImage from 'components/Form/FormImage'
import Spinner from 'react-bootstrap/Spinner'
import * as Yup from 'yup'
import { DevTool } from "react-hook-form-devtools";
import FormColor from 'components/Form/FormColor'
import { updateAccountInfo } from 'store/actions/userActions'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import PricingSection from 'components/PricingSection';
import Section from 'components/Section'
import {useLocation, useHistory} from 'util/router'
import PartnerInformationPage from 'pages/partnerInformation'
import {Helmet} from 'react-helmet'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { saveOffering } from 'store/actions/offeringsActions'
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
const useStyles = makeStyles(styles);

function ChallengeSettingsForm({selectedOffering}) {

    // const selectedOffering = useSelector(state => state.instructor.offerings.find(val => val.id === challengeid))

    const instructor = useSelector(state => state.instructor.instructor);

    const classes = useStyles();

    const dispatch = useDispatch()

    const [isSaving, setIsSaving] = React.useState(false)
    const [saveError, setSaveError] = React.useState(null)
    const [saveSuccess, setSaveSuccess] = React.useState(null)

   

    const { register, control, handleSubmit, setValue, getValues, formState, errors, watch } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            bulletinBoardBody: Yup.string(),
            confirmationEmailBody: Yup.string(),
        }),
        defaultValues: {
            bulletinBoardBody: selectedOffering.bulletinBoardBody ?? "",
            confirmationEmailBody: selectedOffering.confirmationEmailBody ?? "",
            bulletinBoardBodyHTML: selectedOffering.bulletinBoardBodyHTML ?? "",
            confirmationEmailBodyHTML: selectedOffering.confirmationEmailBodyHTML ?? "",
        }
    });

    const { dirty } = formState;

    const htmlPlainText = (html) => {

        console.log("html", html)
        html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
        html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
        html = html.replace(/<\/div>/ig, '\n');
        html = html.replace(/<\/li>/ig, '\n');
        html = html.replace(/<li>/ig, '  *  ');
        html = html.replace(/<\/ul>/ig, '\n');
        html = html.replace(/<\/p>/ig, '\n');
        html = html.replace(/<br\s*[\/]?>/gi, "\n");
        html = html.replace(/<[^>]+>/ig, '');

        return html
    }

    const onSubmit = (data) => {

        if (data.bulletinBoardBody !== selectedOffering?.bulletinBoardBody) {
            var bulletinBoardBody_copy = (' ' + data.bulletinBoardBody).slice(1);
            data.bulletinBoardBodyHTML = bulletinBoardBody_copy
            data.bulletinBoardBody = htmlPlainText(data.bulletinBoardBody)
        }

        if (data.confirmationEmailBody !== selectedOffering?.confirmationEmailBody) {
            var confirmationEmailBody_copy = (' ' + data.confirmationEmailBody).slice(1);
            data.confirmationEmailBodyHTML = confirmationEmailBody_copy
            data.confirmationEmailBody = htmlPlainText(data.confirmationEmailBody)
        }


        const newData = {
            ...selectedOffering,
            ...data
        }

        setIsSaving(true)
        dispatch(saveOffering(newData))
            .then(result => {
                if (result.success === false && result.message) {
                    throw result.message
                }
                setIsSaving(false)
                setSaveError(null)
                setSaveSuccess("Saved!")
            })
            .catch(err => {
                setIsSaving(false)
                setSaveError(`There was an error saving: ${err}`)
                setSaveSuccess(null)
                // window.alert(err)
            })
    }

    useEffect(() => {
        // register({ name: 'dollarDiscount'})
        // register({ name: 'primaryColor'})
    }, [register])


    return (<>
        <form className="" onSubmit={handleSubmit(onSubmit)}>
            <section className="mb-4">
                {saveSuccess && (
                    <div className="alert alert-success" role="alert">
                        {saveSuccess}
                    </div>
                )}
                {saveError && (
                    <div className="alert alert-danger" role="alert">
                        {saveError}
                    </div>
                )}
                <div className="row">
                    <div className="col-md-10">
                        <h2 className="font-weight-bold">Communication Settings</h2>
                        {/* <h2>Business Settings</h2> */}
                    </div>
                    <div className="col-md-2">
                        {/* <button type="submit" className="btn btn-primary">Save changes</button> */}
                        <button disabled={!dirty} type="submit" className="btn btn-primary">
                        
                            <span>{"Save changes"}</span>

                            {isSaving && (
                                <Spinner
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden={true}
                                className="ml-2"
                                >
                                <span className="sr-only">Saving...</span>
                                </Spinner>
                            )}
                        </button>
                        {/* <a href={"https://sutrapro.com/" + (user.widgetName ?? "")} target="_blank">
                            <button type="button" className="btn btn-link">Preview page</button>
                        </a> */}
                        
                    </div>
                </div>
            </section>

            <section>
                <FormGroup
                    type="text"
                    texteditor
                    name="bulletinBoardBody"
                    label="Bulletin Board"
                    sublabel={`An \"always on\" display to tell your students what's going on`}
                    // placeholder={}
                    register={register}
                    error={errors.bulletinBoardBody}
                    fullSize
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />
                <FormGroup
                    type="text"
                    texteditor
                    name="confirmationEmailBody"
                    label="Confirmation Email"
                    sublabel="Decide what to send your students when they sign up"
                    // placeholder={}
                    register={register}
                    error={errors.confirmationEmailBody}
                    fullSize
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />
            </section>
            

        </form>

        <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
                
                <Card>
                    <CardHeader color="primary" icon>
                    <h3 className={classes.cardTitle}>
                        <small>Embed this community in your own website</small>
                    </h3>
                    <p className={classes.cardCategory}>Copy and paste to embed into your own website!</p>
                    </CardHeader>
                    <CardBody>
                    <pre>
                        <code>
                            {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/series/${selectedOffering.id}"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                        </code>
                    </pre>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        <DevTool control={control} />
    </>)
}

function ChallengeSettingsSection(props) {

    const selectedOffering = useSelector(state => state.instructor.offerings.find(val => val.id === props?.challengeid))

    return (
        <div className="container">
            {selectedOffering && (
                <ChallengeSettingsForm selectedOffering={selectedOffering} /> 
                // {...props} />
            )}
            

        </div>
    )
}
export default ChallengeSettingsSection